import { strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from 'admin/component/CommonScreen'
import { Input, Button } from 'antd'
import {
  deleteTpsUnitMappingInfo,
  getTpsUnitMappingInfo,
  postTpsUnitMappingInfo,
} from 'api/pgads'
import {
  UtilityUnitSelection,
  getApiTargetInfo,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
  hasAccesPermits,
} from 'core'
import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
  utilityHeader,
} from 'core/HeaderColTypeProps'
import React, { useMemo, useState } from 'react'
import { connect } from 'react-redux'
import * as ScreenPermissions from 'core/EventActions'

const TpsUnitMapping = props => {
  const { utilityNameMap, unitNameMap, actionPermits } = props
  const [insertEvent, setInsertEvent] = useState(false)

  const title = 'Unit Mapping (TPS)'

  const tpsUnitMappingAccess = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          // ScreenPermissions.TPS_UNIT_MAPPING_READ,
          ScreenPermissions.TPS_UNIT_MAPPING_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const headers = [
    utilityHeader,
    unitIdHeader,
    strCol({
      ident: 'elementName',
      display: 'Element Name',
      width: 450,
      isKey: true,
    }),
    strCol({
      ident: 'pnodeId',
      display: 'PNode Id',
      width: 450,
    }),
    modifierCol,
    modifiedDateCol,
  ]
  const retrieveTask = apiTargetInfo => getTpsUnitMappingInfo(apiTargetInfo)
  const modifyTask = apiTargetInfo => data =>
    postTpsUnitMappingInfo(apiTargetInfo)(data)
  const deleteTask = apiTargetInfo => data =>
    deleteTpsUnitMappingInfo(apiTargetInfo)(data)

  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          // dataGetter: this.generateDataGetter,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitId] || rowData.unitId,
        }
      : /*: header.ident === 'effectiveMonth'
          ? {
              ...header,
              choices: monthOption,
            } */
        header
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          columnGap: '10px',
        }}
      >
        <div>
          Utility/Unit:
          <UtilityUnitSelection
            utility={insertData.utility}
            unit={insertData.unitId}
            style={{ width: '100%' }}
            onUnitChange={value => {
              setInsertData({
                ...insertData,
                utility: value[0],
                unitId: value[1],
                unit: value[1].substr(3),
              })
            }}
          />
        </div>
        <div>
          Element Name:
          <Input
            key="elementName"
            value={insertData.elementName}
            placeholder="elementName"
            name="elementName"
            onChange={e =>
              setInsertData({ ...insertData, elementName: e.target.value })
            }
          />
        </div>
        <div>
          Pnode Id:
          <Input
            key="pnodeId"
            value={insertData.pnodeId}
            placeholder="pnodeId"
            name="pnodeId"
            onChange={e =>
              setInsertData({ ...insertData, pnodeId: e.target.value })
            }
          />
        </div>

        <div style={{ alignSelf: 'end' }}>
          <Button
            type="primary"
            onClick={() => onAdd(true)}
            style={{ marginRight: '10px' }}
          >
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginRight: '10px' }}
          >
            Add & Hide
          </Button>

          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return (
    <CommonScreen
      //   extraCriteriaAfterButton={extraCriteriaAfterButton}
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      //   altBy={d => d.utility}
      autoRetrieve
      widthOffset={50}
      insertComp={tpsUnitMappingAccess && insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => tpsUnitMappingAccess && setInsertEvent(b)}
      autoFixColByKey={false}
      isAdminScreen={false}
      withoutModify={!tpsUnitMappingAccess}
      allowInsert={tpsUnitMappingAccess}
      //   onRetrieveData={reloadUtilityNameMap}
      //   sortEnabled
      // sortOnData={sortOnData}
      //   sortOptions={[
      //     {
      //       ident: 'companyId',
      //       display: 'Company',
      //       sortOrder: 'asc',
      //     },
      //     {
      //       ident: 'utilityName',
      //       display: 'Utility Name',
      //       sortOrder: 'asc',
      //     },
      //   ]}
    />
  )
}

// export default TpsUnitMapping

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(TpsUnitMapping)
